module.exports = __webpack_public_path__ + "static/copper_crm_create_webhook-29a16645fe319616624f07c2962cb032.png";